import { useMemo, type FC } from "react";
import BackgroundTheme from "../../components/general/BackgroundTheme";
import GridContainer from "../../components/general/GridContainer";
import ModuleRenderer, {
	type ModuleRendererProps,
} from "../../components/module-renderer";
import { Breadcrumbs } from "../../containers/breadcrumbs";
import type { Breadcrumb } from "../../utils/breadcrumbs";
import { PageContext } from "./page.container";

type PageComponentProps = {
	title?: string;
	modules: ModuleRendererProps["modules"] | null | undefined;
	backgroundColor?: string;
	breadcrumbs?: Breadcrumb[];
	published_at: string;
};

export const PageComponent: FC<PageComponentProps> = ({
	title,
	modules,
	backgroundColor,
	breadcrumbs,
	published_at,
}) => {
	const pageContextProviderValue = useMemo(
		() => ({ publishedAt: published_at }),
		[published_at],
	);

	return (
		<PageContext.Provider value={pageContextProviderValue}>
			<BackgroundTheme themeColor={backgroundColor} />
			{title && <h1 style={{ display: "none" }}>{title}</h1>}
			{breadcrumbs && <Breadcrumbs breadcrumbs={breadcrumbs} />}

			<GridContainer role="main">
				{modules ? <ModuleRenderer modules={modules} /> : undefined}
			</GridContainer>
		</PageContext.Provider>
	);
};
